import { render, staticRenderFns } from "./zhibiao-select.vue?vue&type=template&id=3b8bb7a2&"
import script from "./zhibiao-select.vue?vue&type=script&lang=ts&"
export * from "./zhibiao-select.vue?vue&type=script&lang=ts&"
import style0 from "./zhibiao-select.vue?vue&type=style&index=0&id=3b8bb7a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports